import * as React from 'react';

import ConsumerLoggedOutHomePageHeader from 'bundles/composable-page-header-consumer/header-renderers/ConsumerLoggedOutHomePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import FrontPageContent from 'bundles/front-page/pages/FrontPageContent';
import FrontPageDataProvider from 'bundles/front-page/providers/FrontPageDataProvider';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

const FrontPage = () => {
  return (
    <FrontPageDataProvider>
      <React.Fragment>
        <ConsumerLoggedOutHomePageHeader />
        <UniversalPageFeatures />
      </React.Fragment>
      <FrontPageContent />
      <PageFooter />
      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />

      <FrontPageGoogleSchemaMarkup />
    </FrontPageDataProvider>
  );
};

export default FrontPage;
